/* eslint-disable */
import { IState } from "@/interfaces/IState";
import { IUser } from "@/interfaces/user/IUser";
import router from "@/router";
import axios from "axios";

export const user = {
    state: {
        user: {},
        institutionId: "",
        isLogged: false
    },
    mutations: {
        SET_USER(state: IState, payload: IUser) {
            state.user = payload;
            state.institutionId = payload.institutionContext.institutionId;
        },
        SET_IS_LOGGED(state: any, payload: Boolean) {
            state.isLogged = payload;
        },

        RESET_USER(state: any) {
            state.user = {},
            state.institutionId = '';
            state.isLogged = false;
        }
    },
    actions: {
        setIsLogged(context: any, payload: Boolean) {
            context.commit("SET_IS_LOGGED", payload);
        },
        async actionGetUser(context: any) {
            await axios
                .get(`${axios.defaults.baseURL}user/getData`)
                .then(res => {
                    context.commit("SET_USER", res.data);
                    context.commit("SET_IS_LOGGED", true);
                    console.info("Usuario cargado Exitosamente", res.data);
                })
                .catch(error => {
                    context.commit("SET_IS_LOGGED", false);
                    console.info("error cargando usuario", error);
                    window.location.href = process.env.VUE_APP_ROMA_LOGIN_CAS;
                });
        },
        async actionLogout(context: any) {
            
            await axios
                .get(`${axios.defaults.baseURL}user/logout`)
                .then(res => {

                    context.commit("SET_USER", {});
                    context.commit("SET_IS_LOGGED", false);
                    context.commit("RESET_USER");
                    console.info("Usuario logout Exitoso");

                })
                .catch(error => {
                    context.commit("SET_IS_LOGGED", false);
                    console.info("error limpiando usuario", error);
                });

        }
    },
    getters: {
        // Get all Lessons
        getUserData(state: IState) {
            return state.user;
        },
        getInstitutionId(state: IState) {
            return state.institutionId;
        },
        getIsLogged(state: any) {
            return state.isLogged;
        }
    }
};
